var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicehotline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    style: {
      enableBackground: "new 0 0 91 91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#6994BB;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#6994BB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_001-kombiVerkehr-SupportBalken"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_001-01-komibverkehr-ServiceHotline_x5F_3.0",
    transform: "translate(-1670.000000, -303.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1670.000000, 303.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st0",
    cx: 45.5,
    cy: 45.5,
    r: 45.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.5,85.8c-22.2,0-40.3-18.1-40.3-40.3S23.3,5.2,45.5,5.2s40.3,18.1,40.3,40.3S67.7,85.8,45.5,85.8z  M45.5,10C25.9,10,10,25.9,10,45.5S25.9,81,45.5,81S81,65.1,81,45.5S65.1,10,45.5,10z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000003064999532000346940000009662130197695632785_",
    className: "st2",
    d: "M56.8,54l-0.7,0V43.7h0.7L56.8,54z M62.7,52 c0,0.3-0.1,0.5-0.3,0.7C62.2,52.9,62,53,61.7,53h-0.8v-8.3h0.8c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7V52z M47.1,62.9h-1.7 c-0.4,0-0.8-0.3-0.8-0.7c0-0.4,0.3-0.7,0.8-0.7h1.7c0.4,0,0.8,0.3,0.8,0.7C47.8,62.6,47.5,62.9,47.1,62.9L47.1,62.9z M28.1,52v-6.4 c0-0.5,0.5-1,1-1h0.8V53h-0.8C28.6,53,28.1,52.6,28.1,52L28.1,52z M34,54h0.7V43.7H34V54z M63.6,41.1v-1.5c0-4.7-1.9-9.1-5.3-12.4 c-3.4-3.3-8.1-5.2-12.9-5.2s-9.5,1.9-12.9,5.2c-3.4,3.3-5.3,7.8-5.3,12.4v1.5c-0.9,0.4-1.7,1-2.3,1.8c-0.6,0.8-0.9,1.8-0.9,2.7V52 c0,1.3,0.5,2.6,1.5,3.5c1,0.9,2.2,1.4,3.6,1.4h1.1c0.4,0.6,1,1,1.8,1h4.8c0.5,0,1.1-0.2,1.4-0.6c0.4-0.4,0.6-0.9,0.6-1.4V41.7 c0-0.5-0.2-1-0.6-1.4c-0.4-0.4-0.9-0.6-1.4-0.6h-4.8c-0.2,0-0.5,0-0.7,0.1v-0.3c0-4.9,2.7-9.4,7.1-11.8c4.4-2.4,9.8-2.4,14.1,0 c4.4,2.4,7.1,7,7.1,11.8v0.3c-0.2-0.1-0.5-0.1-0.7-0.1h-4.8c-0.5,0-1.1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.4V56 c0,0.5,0.2,1,0.6,1.4c0.4,0.4,0.9,0.6,1.4,0.6h4.7c-1,1.6-2.8,2.5-4.7,2.5h-2.4c-0.4-0.9-1-1.6-1.8-2.1c-0.8-0.5-1.7-0.8-2.7-0.8 h-1.7c-1.7,0-3.3,0.9-4.2,2.3c-0.9,1.4-0.9,3.2,0,4.7c0.9,1.4,2.5,2.3,4.2,2.3h1.7c0.9,0,1.7-0.2,2.5-0.7c0.7-0.4,1.4-1.1,1.8-1.8 h2.6c2.3,0,4.5-0.8,6.2-2.2c1.7-1.4,2.9-3.4,3.3-5.6c1-0.4,1.8-1,2.4-1.8c0.6-0.8,0.9-1.8,0.9-2.8v-6.4c0-1-0.3-1.9-0.9-2.7 C65.4,42.1,64.6,41.5,63.6,41.1L63.6,41.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicehotline);
export default __webpack_public_path__ + "static/media/servicehotline.b2445b58a063bf914792028e7e6a1a36.svg";
export { ForwardRef as ReactComponent };